 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"ca91a81e3dd97685bc3f854afbc0b612e13027e0","3":"c311e027fc2efc6f839d87d6a5f2dda464d65934","4":"dc6e1d418655342c1045e1d8842e215880eb1714","5":"6b058876afe5261b4e189d0c638f1adce5fbf413","6":"2bcaff6784a7c9054a87b9b66fc82023fe56897f","7":"9bcbda6c886a25d5e262a42cc242a1a2481c4af8","8":"2da58a7038e51d106101e67aa72908aabfa9d140","9":"3ed803d8","10":"6ff7061ce64dc10736674ebc5b9dbcdba890418c","11":"7fe62155fc7bb070c084f73783c705e540755988","12":"3568003b4c777c5860cca45baa4e44e19058233d","13":"6e2e502798b2f00f9449b7747158a11806f5fb2e","14":"e48519b3","18":"component---src-pages-404-js","19":"component---src-pages-e-shop-cart-js","20":"component---src-pages-e-shop-confirmation-js","21":"component---src-pages-e-shop-delivery-js","22":"component---src-pages-kariera-poradce-pro-investicni-kovy-js","23":"component---src-pages-kontakt-js","24":"component---src-pages-o-nas-js","25":"component---src-pages-thank-you-career-js","26":"component---src-pages-thank-you-contact-js","27":"component---src-pages-thank-you-gold-js","28":"component---src-pages-thank-you-platinum-js","29":"component---src-pages-thank-you-silver-js","30":"component---src-pages-vyvoj-cen-js","31":"component---src-templates-blog-js","32":"component---src-templates-coin-js","33":"component---src-templates-eshop-category-js","34":"component---src-templates-eshop-js","35":"component---src-templates-page-js","36":"component---src-templates-post-js","37":"component---src-templates-product-js"}[chunkId]||chunkId) + "-" + {"0":"f79706864f224bc64e33","1":"e9d24b1846c7d6eb9685","2":"61f542d31d30faec7bf8","3":"ad722a33730cf93cc5a2","4":"e06d60ce5ccf102f6c24","5":"3fcba0d2d0fcf316b138","6":"09e2f56d205af5d062fe","7":"06774350319ae4b06ab0","8":"81eb287c0d74676026ba","9":"ef7f23d22c960d6753ca","10":"de803c8274ed58b304fd","11":"db9919625080bb977bc2","12":"b07f9ed16ac3a8ec621e","13":"4f3941b0157c69569606","14":"4335d7f740f6c143238f","16":"5dbfb580bb05074e262e","18":"178c463e6464cdea5121","19":"6ccdcca99cc92bc1187c","20":"31af6d181e566b408ffd","21":"50873be71fe50121d91f","22":"6bcc3576a6944b07dce5","23":"09c49bb09e7f3d37b39e","24":"76bf16c1ff9f540f7508","25":"079c592fa02dcf4fc4f5","26":"7b15a367b8cb20496273","27":"68b06e09d08da472e5c9","28":"032e8d46b59dc7f48b4a","29":"c51db127e26812ab2e02","30":"25642e76bf6636b56f28","31":"6d2d7c64811edb9b109a","32":"3c2f24411d95694af2e8","33":"d79e51141aba317b8d94","34":"32ce42dd7063c93c8dea","35":"09fb323580104b708ddf","36":"67cde5ead4e27b38ef2e","37":"335d11710bb3cc7afe71"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"ca91a81e3dd97685bc3f854afbc0b612e13027e0","3":"c311e027fc2efc6f839d87d6a5f2dda464d65934","4":"dc6e1d418655342c1045e1d8842e215880eb1714","5":"6b058876afe5261b4e189d0c638f1adce5fbf413","6":"2bcaff6784a7c9054a87b9b66fc82023fe56897f","7":"9bcbda6c886a25d5e262a42cc242a1a2481c4af8","8":"2da58a7038e51d106101e67aa72908aabfa9d140","9":"3ed803d8","10":"6ff7061ce64dc10736674ebc5b9dbcdba890418c","11":"7fe62155fc7bb070c084f73783c705e540755988","12":"3568003b4c777c5860cca45baa4e44e19058233d","13":"6e2e502798b2f00f9449b7747158a11806f5fb2e","14":"e48519b3","18":"component---src-pages-404-js","19":"component---src-pages-e-shop-cart-js","20":"component---src-pages-e-shop-confirmation-js","21":"component---src-pages-e-shop-delivery-js","22":"component---src-pages-kariera-poradce-pro-investicni-kovy-js","23":"component---src-pages-kontakt-js","24":"component---src-pages-o-nas-js","25":"component---src-pages-thank-you-career-js","26":"component---src-pages-thank-you-contact-js","27":"component---src-pages-thank-you-gold-js","28":"component---src-pages-thank-you-platinum-js","29":"component---src-pages-thank-you-silver-js","30":"component---src-pages-vyvoj-cen-js","31":"component---src-templates-blog-js","32":"component---src-templates-coin-js","33":"component---src-templates-eshop-category-js","34":"component---src-templates-eshop-js","35":"component---src-templates-page-js","36":"component---src-templates-post-js","37":"component---src-templates-product-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"73ef79a894f698a829f1","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
